import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateChildFn, Router } from '@angular/router';
import { ApplicationStore } from '@ffx/app-store';

export const authenticationGuard: CanActivateChildFn = async (childRoute, state) => {
    const auth = inject(Auth);
    const router = inject(Router);
    const appStore = inject(ApplicationStore);

    const user = await new Promise<any>((resolve) => {
        auth.onAuthStateChanged((currentUser) => resolve(currentUser));
    });

    if (user && user.email) {
        appStore.setUserAndGetTheme({
            email: user.email,
            uid: user.uid,
            theme: appStore.user.theme()
        });
        return true;
    } else {
        return router.navigate(['/login']);
    }
};
